import React from 'react';
import { btoa , toUnicode } from '../../../cryptographic/crypto';
function QuickResponce({quickRes, socket}) {
    const sendMessage = (e) => {
        let sendData = {
            text : toUnicode(e.title),
            payload: toUnicode(e.payload)
        }
        socket.emit(btoa(["user-send",sendData]));
        document.getElementById("quick-responce-wrapper").classList.add('fadeOut')
    }
    return(
        <div className="quick-responce-wrapper" id="quick-responce-wrapper">
            {
                quickRes?.map((quickRes, i) => (
                   <>
                   
                    <button type="button" className="btn-outline" onClick={(e)=>sendMessage(quickRes)} key={i}>{quickRes.title}</button>
                   </> 
                ))
            }
        </div>
    )
}
export default QuickResponce;
